'use strict';
import React from 'react';
import * as T from 'prop-types';
import {assetsStates} from '../../../assets/router-config';
import {NavigationBar, navigationBarLinkProps} from '../../../components/views/NavigationBar';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {Link} from '../../../app/components/Link';
import {TaskType, isTaskType} from '../../../tasks/enums/TaskType';
import {assetProjectStates, projectStates, projectTemplateStates} from '../../router-config';


export function BaseProjectNavigationBarView(props) {
  const routerStates = getRouterState(props.taskType);
  const isProjectLevel = props.taskType !== TaskType.ASSET;

  return (
    <NavigationBar>
      {!isProjectLevel ? (
        <Link
          {...navigationBarLinkProps}
          navState={props.navState}
          to={assetsStates.assetsHome}
        >
          {props.overviewLabel}
        </Link>
      ) : null}
      <Link
        {...navigationBarLinkProps}
        navState={props.navState}
        to={routerStates.tasks}
      >
        {props.tasksTitle}
      </Link>
      {isProjectLevel ? (
        <Link
          {...navigationBarLinkProps}
          navState={props.navState}
          to={projectTemplateStates.tasks}
        >
          {props.templateTitle}
        </Link>
      ) : null}
      <Link
        {...navigationBarLinkProps}
        navState={props.navState}
        to={routerStates.activityFeed}
      >
        {props.activityFeedTitle}
      </Link>
      {isProjectLevel ? (
        <Link
          {...navigationBarLinkProps}
          navState={props.navState}
          to={projectStates.projectsAssetProjectsList}
        >
          {props.assetsTitle}
        </Link>
      ) : null}
      {showMemberAccess(props.taskType) ? (
        <Link
          {...navigationBarLinkProps}
          navState={props.navState}
          onClick={props.onShowManageAccess}
        >
          {props.manageAccessTitle}
        </Link>
      ) : null}
    </NavigationBar>
  );
}

BaseProjectNavigationBarView.propTypes = {
  taskType: isTaskType.isRequired,
  className: T.string,

  activityFeedTitle: T.string,
  manageAccessTitle: T.string,
  assetsTitle: T.string,
  overviewLabel: T.string,
  tasksTitle: T.string,
  templateTitle: T.string,

  onShowMemberAccess: T.func,
};

export const ProjectNavigationBarView = I18nComponent(BaseProjectNavigationBarView, [
  {code: 'projects.views.activity.title', prop: 'activityFeedTitle'},
  {code: 'projects.views.access.title', prop: 'manageAccessTitle'},
  {code: 'projects.views.assets.title', prop: 'assetsTitle'},
  {code: 'asset.tabs.overview.title', prop: 'overviewLabel'},
  {code: 'projects.views.tasks.title', prop: 'tasksTitle'},
  {code: 'projects.views.template.title', prop: 'templateTitle'},
  {code: 'projects.views.timer.title', prop: 'timerLogTitle'},
]);

function getRouterState(taskType) {
  switch (taskType) {
    case TaskType.ASSET:
      return assetProjectStates;

    case TaskType.PROJECT:
    case TaskType.TEMPLATE:
      return projectStates;
  }
}

function showMemberAccess(taskType) {
  switch (taskType) {
    case TaskType.PROJECT:
    case TaskType.TEMPLATE:
      return true;

    case TaskType.ASSET:
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/components/ProjectNavigationBar/ProjectNavigationBarView.js